import {useIonRouter, useIonToast} from "@ionic/react";
import {linkEmplBroadcast, linkEmplControlCardLocation, linkEmplTicketDetail} from "app/employee/core/employeeLinks";
import {useNativeNotification} from "app/employee/nativeApp/useNativeNotification";
import {markAsReadInAppNotificationAndReload} from "app/employee/notification/utils";
import {isNotNil} from "app/utils/stdlib";

export const NativeNotificationsHandler = () => {
  const [presentToast] = useIonToast();
  const {push} = useIonRouter();

  useNativeNotification(async (notification) => {
    if (notification.__typename === "MessageNotification") {
      console.log("Received notification", notification.message);
      await presentToast({message: notification.message, duration: 5000});
    } else if (notification.__typename == "ControlCardFillIn") {
      push(linkEmplControlCardLocation());
    } else if (notification.__typename == "LoginNotification") {
      console.log("Received login notification, access code", notification.accessCode);
    } else if (notification.__typename == "ManagerBroadcast") {
      push(linkEmplBroadcast(notification.broadcastId, notification.deliveryId));
    } else if (notification.__typename == "Ticket") {
      if (isNotNil(notification.deliveryId)) {
        // Fire-and-forget: a network failure here must not block the deep-link navigation below.
        markAsReadInAppNotificationAndReload(notification.deliveryId).catch((e) => {
          console.error("Failed to mark ticket notification as read", e);
        });
      }
      push(linkEmplTicketDetail(notification.ticketId));
    }
  });

  return null;
};
